/* No autoplay. Native horizontal scrolling remains usable without JavaScript. */
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-dtc-gallery]').forEach(gallery => {
      if (gallery.dataset.galleryReady) return;
      const track = gallery.querySelector('[data-gallery-track]');
      const cards = Array.from(gallery.querySelectorAll('[data-gallery-card]'));
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const position = gallery.querySelector('[data-gallery-position]');
      const controls = gallery.querySelector('[data-gallery-controls]');
      if (!track || !cards.length || !prev || !next || !controls) return;
      gallery.dataset.galleryReady = 'true';
      controls.hidden = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      const current = () => Math.max(0, Math.round(track.scrollLeft / step()));
      const update = () => {
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        if (position) position.textContent = `${current() + 1} / ${cards.length}`;
      };
      const go = index => track.scrollTo({
        left: Math.max(0, Math.min(index, cards.length - 1)) * step(),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
      const pageSize = () => Math.max(1, Math.round(track.clientWidth / step()));
      prev.addEventListener('click', () => go(current() - pageSize()));
      next.addEventListener('click', () => go(current() + pageSize()));
      track.addEventListener('keydown', event => {
        if (event.target !== track || event.altKey || event.ctrlKey || event.metaKey) return;
        const actions = { ArrowLeft: () => go(current() - 1), ArrowRight: () => go(current() + 1), Home: () => go(0), End: () => go(cards.length - 1) };
        if (actions[event.key]) { event.preventDefault(); actions[event.key](); }
      });
      let frame = 0;
      track.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = 0; update(); });
      }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
